<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light m-0 pb-5">
    <div>
      <v-alert
        :type="alert_type"
        :model-value="alert"
        :value="alert"
        transition="scale-transition"
        >{{ alert_message }}</v-alert
      >
    </div>

    <div>
      <div>
        <span>
          <HeaderComponent :headerTitle="headerText" />
        </span>
      </div>

      <v-container class="px-0" fluid grid-list-lg>
            <v-row class="m-0">
               <!-- <v-col xs3 cols="3" sm="3" md="3" class="rounded-card" :elevation="4">
                <v-card class="rounded-card" :elevation="4"  @click="downloadTimelineReport()">
                      <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
                          <v-col class="text-left p-0 d-flex" cols="8">
                            <img src="@/assets/images/icons/line.png" width="20" height="20" alt="icon" class="ma-0 mr-2" />
                            <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                                <span class="font-weight-bold">Inward Report</span>
                            </h4>
                          </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                          <v-col class="p-0">
                            <div class="text-center" style="cursor: pointer;">
                                <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                                View
                                </a>
                            </div>
                          </v-col>
                      </v-row>
                </v-card>
              </v-col> -->
              <!-- <v-col xs3 cols="3" sm="3" md="3" class="rounded-card" :elevation="4">
                <v-card class="rounded-card" :elevation="4"  >
                <router-link :to="{ name: 'GrnReport' }">
                      <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
                          <v-col class="text-left p-0 d-flex" cols="8">
                            <img src="@/assets/images/icons/realtime.png" width="20" height="20" alt="icon" class="ma-0 mr-2" />
                            <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                                <span class="font-weight-bold">Real Time GRN</span>
                            </h4>
                          </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                          <v-col class="p-0">
                            <div class="text-center" style="cursor: pointer;">
                                <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                                View
                                </a>
                            </div>
                          </v-col>
                      </v-row>
                </router-link>
                </v-card>
              </v-col> -->
              <v-col xs3 cols="3" sm="3" md="3" class="rounded-card" :elevation="4">
                <v-card class="rounded-card" :elevation="4">
                  <router-link :to="{ name: 'ClosedReport' }">
                      <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
                          <v-col class="text-left p-0 d-flex" cols="8">
                            <img src="@/assets/images/icons/line.png" width="20" height="20" alt="icon" class="ma-0 mr-2" />
                            <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                                <span class="font-weight-bold">Closed Report</span>
                            </h4>
                          </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                          <v-col class="p-0">
                            <div class="text-center" style="cursor: pointer;">
                                <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                                View
                                </a>
                            </div>
                          </v-col>
                      </v-row>
                  </router-link>
                </v-card>
              </v-col>
              <v-col
                xs3
                cols="3"
                sm="3"
                md="3"
                class="rounded-card"
                :elevation="4"
                v-for="standalone_report in standalone_reports"
                :key="standalone_report.id"
              >
                <v-card class="rounded-card" :elevation="4">
                  <v-row align="center" style="margin:20px 25px 5px; cursor: pointer;">
                      <v-col class="text-left p-0 d-flex" cols="12">
                        <img src="@/assets/images/icons/line.png" width="20" height="20" alt="icon" class="ma-0 mr-2" />
                        <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                            <span class="font-weight-bold">{{ humanizeReportName(standalone_report.name) }}</span>
                        </h4>
                      </v-col>
                  </v-row>
                  <v-row style="margin:0 25px 20px;">
                      <v-col class="text-left p-0" cols="12">
                        <span style="font-size: 12px; color: #666666;">{{ formatReportDate(standalone_report.created_at) }}</span>
                      </v-col>
                  </v-row>
                  <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                      <v-col class="p-0">
                        <div class="text-center" style="cursor: pointer;">
                            <a href="#" @click.prevent="downloadReport(standalone_report.report_url)" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                            Download
                            </a>
                        </div>
                      </v-col>
                  </v-row>
                </v-card>
              </v-col>
              <!-- <v-col xs3 cols="3" sm="3" md="3" class="rounded-card" :elevation="4">
                <v-card class="rounded-card" :elevation="4">
                      <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
                          <v-col class="text-left p-0 d-flex" cols="8">
                            <img src="@/assets/images/icons/line.png" width="20" height="20" alt="icon" class="ma-0 mr-2" />
                            <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                                <span class="font-weight-bold">Generated Report</span>
                            </h4>
                          </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                          <v-col class="p-0">
                            <div class="text-center" style="cursor: pointer;">
                                <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                                View
                                </a>
                            </div>
                          </v-col>
                      </v-row>
                </v-card>
              </v-col> -->
            </v-row>
      </v-container>

      <!-- <v-row class="m-0">
        <v-col
          cols="6"
          sm="6"
          md="6"
          v-if="currentUser.roles.includes('central_admin')"
        >
          <v-card
            class="overflow-hidden v-sheet theme--light"
            style="width: 100%"
            elevation="1"
          >
            <v-card-title class="text-left">
              <span class="headline" text-size="small"> Inward Report </span>
            </v-card-title>
            <v-card-text>
              <v-flex class xs12 style="background-color: grey lighten-3">
                <a
                  style="display: none"
                  id="rpa_report"
                  small
                  tile
                  color="#F3F3F3"
                  href=""
                  target="_blank"
                  download
                >
                </a>
                <v-row>
                  <v-col cols="6" sm="6" md="5">
                    <v-card
                      class="pa-4 box_shadow_class"
                      @click="downloadTimelineReport()"
                    >
                      <div align="center" justify="center">
                        <img
                          class="mt-3"
                          src="@/assets/images/icons/inward_visibility.svg"
                          width="108"
                          height="108"
                        />
                      </div>
                      <div
                        class="mt-3 text-color"
                        align="center"
                        justify="center"
                      >
                        Inward Report
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="6" sm="6" md="6">
          <v-card
            class="overflow-hidden v-sheet theme--light"
            style="width: 100%;"
            elevation="1"
          >
            <v-card-title class="text-left">
              <span class="headline" text-size="small">
                RPA Report - Brand
              </span>
            </v-card-title>
            <v-card-text>
              <v-flex class xs12 style="background-color: grey lighten-3">
                <v-row class="ml-3">
                  <v-col cols="6" sm="6" md="6">
                  <v-card
                    class="pa-4 box_shadow_class"
                    @click="downloadRpaReport('Brand Wise RPA Inv')"
                  >
                    <div align="center" justify="center">
                      <img
                        class="mt-3"
                        src="@/assets/images/icons/price-tag 1.png"
                        width="108"
                        height="108"
                      />
                    </div>
                    <div
                      class="mt-3 text-color"
                      align="center"
                      justify="center"
                    >
                      RPA Report - Brand
                    </div>
                  </v-card>
                </v-col>
                </v-row>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="ml-1 mt-3">
        <v-card
          class="overflow-hidden v-sheet theme--light"
          style="width: 100%"
          elevation="1"

        >
          <v-card-title class="text-left">
            <span class="headline" text-size="small"> RPA Report - Daily </span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="3" sm="3" md="3">
                <v-card
                  class="pa-4 box_shadow_class"
                  @click="downloadRpaReport('RPA Report')"
                >
                  <div align="center" justify="center">
                    <img
                      class="mt-3"
                      src="@/assets/images/icons/exchange 1.png"
                      width="108"
                      height="108"
                    />
                  </div>
                  <div class="mt-3 text-color" align="center" justify="center">
                    RPA Report
                  </div>
                </v-card>
              </v-col>

              <v-col cols="3" sm="3" md="3">
                <v-card
                  class="pa-4 box_shadow_class"
                  @click="downloadRpaReport('Brand Manager')"
                >
                  <div align="center" justify="center">
                    <img
                      class="mt-3"
                      src="@/assets/images/icons/team 1.png"
                      width="108"
                      height="108"
                    />
                  </div>
                  <div class="mt-3 text-color" align="center" justify="center">
                    RPA - Manager
                  </div>
                </v-card>
              </v-col>

              <v-col cols="3" sm="3" md="3">
                <v-card
                  class="pa-4 box_shadow_class"
                  @click="downloadRpaReport('Overall RPA Inv')"
                >
                  <div align="center" justify="center">
                    <img
                      class="mt-3"
                      src="@/assets/images/icons/location 1.png"
                      width="108"
                      height="108"
                    />
                  </div>
                  <div class="mt-3 text-color" align="center" justify="center">
                    RPA - Location
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-row>

      <v-row class="ml-1 mt-3">
        <v-col cols="6" sm="6" md="6">
          <v-card
            class="overflow-hidden v-sheet theme--light"
            style="width: 100%"
            elevation="1"
          >
            <v-card-title class="text-left">
              <span class="headline" text-size="small">
                RPA Report - More Than 90 Days
              </span>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <v-card
                    class="pa-4 box_shadow_class"
                    @click="downloadRpaReport('Brand More Than 90')"
                  >
                    <div align="center" justify="center">
                      <img
                        class="mt-3"
                        src="@/assets/images/icons/medal 1.png"
                        width="108"
                        height="108"
                      />
                    </div>
                    <div
                      class="mt-3 text-color"
                      align="center"
                      justify="center"
                    >
                      Brand
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-card
                    class="pa-4 box_shadow_class"
                    @click="downloadRpaReport('OL More Than 90')"
                  >
                    <div align="center" justify="center">
                      <img
                        class="mt-3"
                        src="@/assets/images/icons/badge-1.png"
                        width="108"
                        height="108"
                      />
                    </div>
                    <div
                      class="mt-3 text-color"
                      align="center"
                      justify="center"
                    >
                      OL
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="6" sm="6" md="6">
          <v-card
            class="overflow-hidden v-sheet theme--light"
            style="width: 100%"
            elevation="1"
          >
            <v-card-title class="text-left">
              <span class="headline" text-size="small">
                RPA Report - Intransit
              </span>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <v-card
                    class="pa-4 box_shadow_class"
                    @click="downloadRpaReport('In-Transit')"
                  >
                    <div align="center" justify="center">
                      <img
                        class="mt-3"
                        src="@/assets/images/icons/shapes-and-symbols 1.png"
                        width="108"
                        height="108"
                      />
                    </div>
                    <div
                      class="mt-3 text-color"
                      align="center"
                      justify="center"
                    >
                      Intransit
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="ml-1 mt-3">
        <v-col cols="6" sm="6" md="6">
          <v-card
            class="overflow-hidden v-sheet theme--light"
            style="width: 100%"
            elevation="1"
          >
            <v-card-title class="text-left">
              <span class="headline" text-size="small">
                RPA Report - Weekly
              </span>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <v-card
                    class="pa-4 box_shadow_class"
                    @click="downloadRpaReport('RPA In and Out Tracker')"
                  >
                    <div align="center" justify="center">
                      <img
                        class="mt-3"
                        src="@/assets/images/icons/arrows-outline-up-and-down-1.png"
                        width="108"
                        height="108"
                      />
                    </div>
                    <div
                      class="mt-3 text-color"
                      align="center"
                      justify="center"
                    >
                      Inward and Outward
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-card
                    class="pa-4 box_shadow_class"
                    @click="downloadRpaReport('RPA Sitewise Transfer')"
                  >
                    <div align="center" justify="center">
                      <img
                        class="mt-3"
                        src="@/assets/images/icons/destination-1.png"
                        width="108"
                        height="108"
                      />
                    </div>
                    <div
                      class="mt-3 text-color"
                      align="center"
                      justify="center"
                    >
                      Sitewise
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row> -->
    </div>
  </v-card>
</template>

<style scoped>
.v-tabs:not(.v-tabs--vertical):not(.v-tabs--right)
  > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(
    .v-slide-group--has-affixes
  )
  .v-slide-group__prev {
  display: none;
  visibility: hidden;
}
.text-color {
  color: #0357d0;
}
.header-background {
  background-color: #0357d0;
}
.box_shadow_class {
  background: #ffffff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25) !important;
  border-radius: 4px;
}

.v-card {
  max-width: 97% !important;
}

.v-card-100 {
  max-width: 100% !important;
}
.rounded-card{
        border-radius: 12px;
        overflow: hidden;
    }
</style>

<script>
import moment from "moment";
import { mapState } from "vuex";
import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
export default {
  data() {
    return {
      active_tab: "Billing",
      headerText: "Reports",
      start_date: "",
      end_date: "",
      alert: false,
      alert_type: "success",
      alert_message: "success",
      menu_10: false,
      menu_14: false,
      standalone_reports: [],
    };
  },
  components: {
    HeaderComponent,
  },
  computed: mapState(["currentUser", "signedIn"]),

  mounted() {
    this.getStandaloneReports();
  },

  methods: {
    getStandaloneReports() {
      this.$httpSecured
        .get("/api/v2/reports")
        .then((response) => {
          this.standalone_reports = response.data || [];
        })
        .catch(() =>
          this.showAlert("error", "Error in fetching reports"),
        );
    },

    humanizeReportName(name) {
      return (name || "")
        .replace(/_/g, " ")
        .replace(/\b\w/g, (character) => character.toUpperCase());
    },

    formatReportDate(value) {
      return value ? moment(String(value)).format("DD-MM-YYYY hh:mm A") : "";
    },

    downloadReport(reportUrl) {
      if (!reportUrl) return;
      const link = document.createElement("a");
      link.href = reportUrl;
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 6000);
    },

    showAlert(alertType, alertMessage) {
      this.alert = true;
      this.alert_type = alertType;
      this.alert_message = alertMessage;
      this.alertTimeOut();
    },

    loadData(tab) {
      this.active_tab = tab;
    },

    downloadPDF() {
      this.showAlert("success", "Report Will be autodownloaded please wait");
      this.$httpSecured
        .get("/api/v1/warehouse/wms/gate_passes/export_pending_grn_inventories")
        .then((response) => {
          this.file_url = response.data.url;
          document.getElementById("grn_report").href = response.data.url;
          document.getElementById("grn_report").click();
        })
        .catch(() =>
          this.showAlert("error", "Error in fetching pending GRN inventories"),
        );
    },

    downloadRpaReport(dailyReportType) {
      this.showAlert("success", "Report will be Auto Downloaded Please wait.");
      this.$httpSecured

        .get("/api/v1/warehouse/wms/gate_passes/export_daily_report", {
          params: { daily_report_type: dailyReportType },
        })
        .then((response) => {
          this.file_url = response.data.url;
          document.getElementById("rpa_report").href = response.data.url;
          document.getElementById("rpa_report").click();
        })
        .catch(() => this.showAlert("error", "Error in fetching report"));
    },
    downloadTimelineReport() {
      this.$httpSecured
        .get("/api/v1/warehouse/wms/gate_passes/timeline_report")
        .then((response) => {
          this.showAlert(
            "success",
            "Report will be sent on your registered email address " +
              this.$store.state.currentUser.email,
          );
          this.start_date = "";
          this.end_date = "";
        })
        .catch(() =>
          this.showAlert("error", "Error in fetching visibility Report"),
        );
    },
    navigateTarget(routerName) {
      this.$router.push({ name: routerName });
    },
  },
};
</script>
